import type { Translations } from './en';

export const bn: Translations = {
  'nav.inPlay': 'ইন-প্লে',
  'nav.aviator': 'Aviator',

  // Bottom navigation bar
  'bottomNav.home': 'হোম',
  'bottomNav.inPlay': 'ইন-প্লে',
  'bottomNav.offers': 'অফার',
  'bottomNav.myMarkets': 'আমার মার্কেট',
  'bottomNav.referral': 'রেফারেল',
  'bottomNav.passbook': 'পাসবুক',
  'bottomNav.profile': 'প্রোফাইল',

  'common.deposit': 'জমা দিন',
  'common.withdraw': 'উত্তোলন',
  'common.rules': 'নিয়ম',
  'common.all': 'সব',
  'common.viewAll': 'সব দেখুন',
  'common.loading': 'লোড হচ্ছে...',
  'auth.login': 'লগইন',
  'auth.signup': 'সাইন আপ',

  'language.select': 'ভাষা নির্বাচন করুন',

  'search.placeholder': 'ম্যাচ / ক্যাসিনো গেম খুঁজুন',

  'search.short': 'খুঁজুন',
  'search.matches': 'ম্যাচ',
  'search.casinoGames': 'ক্যাসিনো গেম',
  'search.searching': 'খোঁজা হচ্ছে…',
  'search.noResults': '“{term}”-এর জন্য কোনো ফলাফল নেই',
  'search.hint': 'কোনো দল, লিগ বা গেমের নাম চেষ্টা করুন।',

  'menu.accountStatement': 'অ্যাকাউন্ট স্টেটমেন্ট',
  'menu.betHistory': 'বেট ইতিহাস',
  'menu.activityLogs': 'কার্যকলাপ লগ',
  'menu.casinoBetHistory': 'ক্যাসিনো বেট ইতিহাস',
  'menu.bonusStatement': 'বোনাস স্টেটমেন্ট',
  'menu.referral': 'রেফারেল',
  'menu.setButtonValues': 'বাটনের মান সেট করুন',
  'menu.changePassword': 'পাসওয়ার্ড পরিবর্তন করুন',
  'menu.balance': 'ব্যালেন্স',
  'menu.exposure': 'এক্সপোজার',
  'menu.signOut': 'সাইন আউট',

  'sidebar.sports': 'খেলা',
  'sidebar.casino': 'ক্যাসিনো',
  'sidebar.soon': 'শীঘ্রই',
  'sidebar.noCompetitions': 'কোনো প্রতিযোগিতা নেই',
  'sidebar.noMatches': 'কোনো ম্যাচ নেই',

  'home.casinoProviders': 'ক্যাসিনো প্রদানকারী',
  'home.live': 'লাইভ',
  'home.virtual': 'ভার্চুয়াল',
  'home.noLiveMatches': 'এখন কোনো লাইভ ম্যাচ নেই',
  'home.noMatches': 'কোনো ম্যাচ উপলব্ধ নেই',

  'sport.Cricket': 'ক্রিকেট',
  'sport.Football': 'ফুটবল',
  'sport.Tennis': 'টেনিস',
  'sport.Kabaddi': 'কাবাডি',
  'sport.Politics': 'রাজনীতি',
  'sport.Basketball': 'বাস্কেটবল',
  'sport.Baseball': 'বেসবল',
  'sport.Table Tennis': 'টেবিল টেনিস',
  'sport.Volleyball': 'ভলিবল',
  'sport.Ice Hockey': 'আইস হকি',
  'sport.Rugby': 'রাগবি',
  'sport.Mixed Martial Arts': 'মিক্সড মার্শাল আর্টস',
  'sport.Darts': 'ডার্টস',
  'sport.Futsal': 'ফুটসাল',
  'sport.Horse Racing': 'ঘোড়দৌড়',
  'sport.Greyhound Racing': 'গ্রেহাউন্ড রেসিং',

  'market.limits': 'সর্বনিম্ন: {min} | সর্বোচ্চ: {max}',
  'market.cashout': 'ক্যাশআউট',

  'menu.profile': 'প্রোফাইল',
  'menu.transactionReport': 'লেনদেন রিপোর্ট',
  'profile.activeBets': 'সক্রিয় বেট',
  'profile.joinUs': 'আমাদের সাথে যোগ দিন',
  'profile.logout': 'লগ আউট',
  'profile.balance': 'ব্যালেন্স',

  'profile.description': 'আপনার ব্যালেন্স, ওয়ালেট, সংরক্ষিত অ্যাকাউন্ট ও রিপোর্ট এক জায়গায়।',
  'profile.exposure': 'এক্সপোজার',
  'profile.bonus': 'বোনাস',

  // Deposit popup
  'deposit.availableBalance': 'উপলব্ধ ব্যালেন্স',
  'deposit.coins': 'কয়েন জমা দিন',
  'deposit.enterCoins': 'কয়েন লিখুন',
  'deposit.makePayment': 'পেমেন্ট করুন',
  'deposit.loadingMethods': 'পেমেন্ট পদ্ধতি লোড হচ্ছে...',
  'deposit.methodsError': 'পেমেন্ট পদ্ধতি লোড করা যায়নি। আবার চেষ্টা করুন।',
  'deposit.noMethods': 'এখন কোনো পেমেন্ট পদ্ধতি উপলব্ধ নেই।',
  'deposit.uploadScreenshot': 'পেমেন্টের স্ক্রিনশট আপলোড করতে এখানে ক্লিক করুন',
  'deposit.optional': '(ঐচ্ছিক)',
  'deposit.utrLabel': 'ইউনিক লেনদেন রেফারেন্স (UTR)',
  'deposit.utrPlaceholder': '6 থেকে 23 সংখ্যার UTR/RRN নম্বর',
  'deposit.txHash': 'লেনদেন হ্যাশ',
  'deposit.paste': 'পেস্ট',
  'deposit.copy': 'কপি',
  'deposit.submit': 'সাবমিট করুন',
  'deposit.submitting': 'সাবমিট হচ্ছে...',
  'deposit.scanning': 'স্ক্রিনশট থেকে UTR পড়া হচ্ছে...',
  'deposit.scanFound': 'আপনার স্ক্রিনশট থেকে UTR পূরণ করা হয়েছে, মিলছে কিনা যাচাই করুন।',
  'deposit.scanNotFound': 'স্ক্রিনশট থেকে UTR পড়া যায়নি, অনুগ্রহ করে লিখুন।',
  'deposit.upiId': 'UPI আইডি',
  'deposit.name': 'নাম',
  'deposit.walletAddress': 'ওয়ালেট ঠিকানা',
  'deposit.send': 'পাঠান',
  'deposit.rateUnavailable': 'রূপান্তর হার পাওয়া যাচ্ছে না, পরে আবার চেষ্টা করুন।',
  'deposit.range': '{min} থেকে {max} কয়েনের মধ্যে জমা দিন',
  'deposit.rangeFrom': 'ন্যূনতম জমা {min} কয়েন',
  'deposit.noMethodForAmount': 'এই পরিমাণের জন্য কোনো পেমেন্ট পদ্ধতি নেই। পরিমাণ পরিবর্তন করুন।',
  'deposit.displayName': 'প্রদর্শিত নাম',
  'deposit.upiDetails': 'UPI বিবরণ',
  'deposit.bankDetails': 'ব্যাংকের বিবরণ',
  'deposit.cryptoDetails': 'ক্রিপ্টো বিবরণ',
  'deposit.bankName': 'ব্যাংকের নাম',
  'deposit.accountHolderName': 'অ্যাকাউন্টধারীর নাম',
  'deposit.accountNumber': 'অ্যাকাউন্ট নম্বর',
  'deposit.ifsc': 'IFSC কোড',
  'deposit.amount': 'পরিমাণ',
  'deposit.hashCode': 'হ্যাশ কোড',
  'deposit.enterHash': 'হ্যাশ কোড লিখুন',

  // Withdraw popup
  'withdraw.coins': 'কয়েন উত্তোলন করুন',
  'withdraw.minimum': 'ন্যূনতম উত্তোলনের পরিমাণ {min} কয়েন',
  'withdraw.overBalance': 'পরিমাণটি আপনার উপলব্ধ ব্যালেন্সের চেয়ে বেশি',
  'withdraw.continue': 'চালিয়ে যান',
  'withdraw.loadingAccounts': 'আপনার অ্যাকাউন্ট লোড হচ্ছে...',
  'withdraw.accountsError': 'আপনার অ্যাকাউন্ট লোড করা যায়নি। আবার চেষ্টা করুন।',
  'withdraw.noAccounts':
    'এখনো কোনো সংরক্ষিত অ্যাকাউন্ট নেই। উত্তোলনের জন্য ব্যাংক, UPI বা ক্রিপ্টো অ্যাকাউন্ট যোগ করুন।',
  'withdraw.addAccount': 'অ্যাকাউন্ট যোগ করুন',
  'withdraw.bankAccount': 'ব্যাংক অ্যাকাউন্ট',
  'withdraw.cryptoWallet': 'ক্রিপ্টো ওয়ালেট',
  'withdraw.accountHolder': 'অ্যাকাউন্টধারী',
  'withdraw.accountNumber': 'অ্যাকাউন্ট নম্বর',
  'withdraw.ifsc': 'IFSC',
  'withdraw.amount': 'পরিমাণ',
  'withdraw.youReceive': 'আপনি পাবেন',
  'withdraw.submit': 'উত্তোলন {amount}',
  'withdraw.processing': 'প্রক্রিয়া চলছে...',
};
